import styled from 'styled-components'
import variables from '../../styles/variables'

export const Table = styled.div`
  width: 100%;
  background: white;
  border: 1px solid #f2f2f2;
`
export const TableCell = styled.div`
  padding: 10px;
  font-size: 0.7rem;
  @media ${variables.media.sm} {
    padding: 30px;
    font-size: 1rem;
  }
`

export const AspectRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f2f2f2;
  ${TableCell}:nth-child(1) {
    width: 31%;
  }
  ${TableCell}:nth-child(2) {
    width: 23%;
  }
  ${TableCell}:nth-child(3) {
    width: 23%;
  }
  ${TableCell}:nth-child(4) {
    width: 23%;
  }
  @media ${variables.media.sm} {
    ${TableCell}:nth-child(1) {
      width: 40%;
    }
    ${TableCell}:nth-child(2) {
      width: 20%;
    }
    ${TableCell}:nth-child(3) {
      width: 20%;
    }
    ${TableCell}:nth-child(4) {
      width: 20%;
    }
  }
`
export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  ${AspectRow}:nth-child(1) {
    color: white;
    background: ${variables.colors.silverTree.darker};
  }
  ${AspectRow}:last-child {
    border-bottom: none;
  }
`
